import { currencyFormat } from 'nike-ui/src/common/util';
import { formatCurrency, formatMoney } from '@/common/client';

const EUR = 'EUR';

export const STAKE_CURRENCY = Object.freeze({
    EUR: 'EUR',
    NIK: 'NIK'
});

export function formatBetslipMoney(amount, currency = STAKE_CURRENCY.EUR) {
    // eslint-disable-next-line eqeqeq
    const formattedAmount = currencyFormat(amount, currency == STAKE_CURRENCY.EUR ? 2 : 0) || '0';
    return formattedAmount.replace('.', ',') + ' ' + formatCurrency(currency || 'EUR');
}

export function formatBetslipMoneyRemoveZeros(amount, currency) {
    const formattedAmount = removeTailingZeros(currencyFormat(amount, 2) || '0');
    return formattedAmount + ' ' + formatCurrency(currency || 'EUR');
}

function removeTailingZeros(formattedAmount) {
    if (!formattedAmount || !formattedAmount.length) {
        return formattedAmount;
    }
    return formattedAmount.replace(/([0-9]+([.,][0-9]+[1-9])?)([.,]?0+$)/, '$1');
}

export function formatStakeMoney(ticket, customerId, removeTailingZeros) {
    const pointsStake = ticket.pointsStake;
    const stake = pointsStake ? ticket.pointsStakeAmount : ticket.stake;
    const currency = pointsStake ? 'NIK' : EUR;
    const decPlaces = pointsStake ? 0 : 2;

    if (removeTailingZeros) {
        return formatBetslipMoneyRemoveZeros(stake, currency);
    }
    return formatMoney(stake, currency, decPlaces);
}
